const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGIN_FAILURE = "LOGIN_FAILURE";

export { LOGIN_SUCCESS, LOGIN_FAILURE };
